module.exports = __webpack_public_path__ + "static/media/etichettaAmbassador.7737f9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/ambassador/etichettaAmbassador.png
// module id = 601
// module chunks = 0